export default "__VITE_ASSET__64ca78ce__"